var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fw-time-card"},[_c('div',{staticClass:"fw-time-card__time-wrapper",on:{"click":_vm.handleClick}},[_c('div',{staticClass:"fw-time-card__label",style:({
                 backgroundColor: _vm.getColorByDistance(_vm.timeCardData.distance),
                 borderColor: _vm.getColorByDistance(_vm.timeCardData.distance)
             })}),_vm._l((_vm.timeCardData.dates),function(time){return _c('div',{key:time,staticClass:"fw-time-card__time"},[_vm._v(" "+_vm._s(time)+" ")])})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }